// All Ideal Entertainment content — sourced & restructured from idealentertainment.com

export const BRAND = {
  name: "Ideal Entertainment",
  logo: "https://customer-assets.emergentagent.com/job_determined-darwin-6/artifacts/3v81avpx_logo-1.png",
  tagline: "Connecting People with Ideal Entertainment",
  mission:
    "Ideal Entertainment aspires to showcase to a global audience, quality entertainment by creating innovative content and soulful experiences with multi-faceted, talented artists and brands — producing original theme-based films, music and events on a worldwide platform.",
  // Editable contact details (update with verified business info)
  phone: "+1 (416) 356-6500",
  whatsapp: "14163566500",
  email: "info@idealentertainment.com",
  address: "Toronto, ON, CA",
  socials: {
    instagram: "https://www.instagram.com/",
    youtube: "https://www.youtube.com/",
    facebook: "https://www.facebook.com/",
  },
};

export const IMAGES = {
  heroBg:
    "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  heroAlt:
    "https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  aboutPortrait:
    "https://images.unsplash.com/photo-1507676385008-e7fb562d11f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  ctaBg:
    "https://images.unsplash.com/photo-1563841930606-67e2bce48b78?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
};

export const NAV = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Productions", path: "/productions" },
  { label: "Gallery", path: "/gallery" },
  { label: "News", path: "/news" },
  { label: "Contact", path: "/contact" },
];

export const WHY_US = [
  {
    title: "Visionary Storytelling",
    desc: "Original, theme-based films and immersive narratives crafted with world-class directors and artists.",
  },
  {
    title: "Global Platform",
    desc: "We connect multi-faceted talent and brands with audiences across continents and formats.",
  },
  {
    title: "Innovation First",
    desc: "From virtual-reality cinema to interactive concert films, we pioneer new entertainment experiences.",
  },
  {
    title: "Soulful Experiences",
    desc: "Every production is engineered to move people — quality entertainment that lingers long after the credits.",
  },
];

export const SERVICES = [
  {
    id: "film",
    title: "Film Production",
    short: "Original theme-based feature films",
    desc: "End-to-end production of original feature films — development, financing, production and post — partnering with acclaimed directors and rising talent.",
    image:
      "https://images.unsplash.com/photo-1518930259200-3e5b29f42096?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: "music",
    title: "Music Production",
    short: "Soundtracks, scores & original music",
    desc: "Producing soulful, genre-defining music and soundtracks with world-renowned composers and multi-faceted artists.",
    image:
      "https://images.unsplash.com/photo-1531651008558-ed1740375b39?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: "events",
    title: "Live Events & Concerts",
    short: "Tours, concerts & live experiences",
    desc: "Conceiving and producing large-scale concerts, tours and live experiences that translate artistry into unforgettable nights.",
    image:
      "https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  },
  {
    id: "vr",
    title: "VR & Immersive Cinema",
    short: "Next-generation cinematic formats",
    desc: "Pioneering virtual-reality films and immersive experiences that place the audience inside the story.",
    image:
      "https://images.unsplash.com/photo-1593508512255-86ab42a8e620?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: "content",
    title: "Original Content",
    short: "Documentaries & branded stories",
    desc: "Developing documentaries, branded content and theme-based originals that capture culture and craft.",
    image:
      "https://images.unsplash.com/photo-1632187989763-c9c620420b4d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: "distribution",
    title: "Global Distribution",
    short: "Worldwide reach for your story",
    desc: "Bringing productions to audiences worldwide across theatrical, streaming, festival and live platforms.",
    image:
      "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
];

export const PRODUCTIONS = [
  {
    title: "STEP UP",
    year: "2026",
    category: "Live Event · Dance Championship",
    tag: "Live Championship",
    imgPos: "center",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/xtbhxmuy_Document%201.png",
    desc: "Presented by Ideal Dream Entertainment at the Great Canadian Casino Resort Toronto, STEP UP brought eight of Canada's emerging dance crews together for a live championship — with Indian dance icon Prabhu Deva joining as a special presence. A platform built to turn local South Asian talent into global opportunity.",
  },
  {
    title: "Le Musk",
    year: "2022",
    category: "VR Cinema",
    tag: "Immersive",
    imgPos: "76% 50%",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/qjfhdkh1_MV5BZWM1NzEzNDktYzQ0OC00ZTA0LWEwNDgtZTdiODRlMWVjNjQ3XkEyXkFqcGc%40._V1_.webp",
    desc: "A. R. Rahman's directorial debut ventures into a new kind of cinematic experience. A virtual-reality film, filmed in Rome, that truly immerses the audience into a musically driven experience. An English-language film produced by Ideal Entertainment, Thenandal Studio Limited, Zilvermeer Productions and Intel.",
  },
  {
    title: "99 Songs",
    year: "2021",
    category: "Romantic Musical",
    tag: "Feature Film",
    imgPos: "10% 45%",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/j8balwrv_99%20song.png",
    desc: "Produced in collaboration with YM Movies, '99 Songs' is a feature-length romantic musical, written by A. R. Rahman and directed by Vishwesh Krishnamoorthy as his directorial debut — an experiential movie about one man's struggle against the old and new world.",
  },
  {
    title: "Galaxy Built on Hope",
    year: "Documentary",
    category: "Documentary",
    tag: "Behind the Story",
    imgPos: "45% 50%",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/6nt5y8io_maxresdefault.jpg",
    desc: "Ever wonder how it was made — and who the brains behind all those cool droids and gadgets were? We bring you the incredible story of the hows, the whys and the whos of one of the greatest franchises of all time, spanning four decades of the force.",
  },
  {
    title: "One Heart",
    year: "Concert Film",
    category: "Concert Film",
    tag: "Music",
    imgPos: "22% 30%",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/4tyrelo8_ar-rahman-film-79.webp",
    desc: "The concert film 'One Heart' invites fans behind the scenes of A. R. Rahman's North American Tour, delivering a personal experience into the mind of the world-renowned maestro.",
  },
  {
    title: "She Came Back",
    year: "2024",
    category: "Horror / Thriller",
    tag: "New Release",
    imgPos: "5% 30%",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/xic16t0l_she%20came%20back.png",
    desc: "On the way to her father's wedding, 16-year-old Charlie McLeod is involved in a serious car accident, leaving her in a fight for her life. For a brief moment she dies on the table and has a near-death experience, reconnecting with her deceased mother, Janet. Charlie survives — but Janet's spirit, so moved by the reconnection, has no intention of letting go.",
  },
];

export const STATS = [
  { value: 6, suffix: "+", label: "Original Productions" },
  { value: 3, suffix: "", label: "Continents Reached" },
  { value: 40, suffix: "+", label: "Collaborating Artists" },
  { value: 1, suffix: "M+", label: "Audience Worldwide" },
];

export const TIMELINE = [
  { year: "2021", title: "99 Songs", desc: "Romantic musical written by A. R. Rahman hits cinemas worldwide.", image: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/03pktkw3_images%20%281%29.jpg" },
  { year: "2022", title: "Le Musk", desc: "A. R. Rahman's VR directorial debut, filmed in Rome, premieres.", image: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/qjfhdkh1_MV5BZWM1NzEzNDktYzQ0OC00ZTA0LWEwNDgtZTdiODRlMWVjNjQ3XkEyXkFqcGc%40._V1_.webp" },
  { year: "2023", title: "Galaxy Built on Hope", desc: "Documentary exploring the craft behind a legendary franchise.", image: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/6nt5y8io_maxresdefault.jpg" },
  { year: "2023", title: "One Heart", desc: "Concert film capturing A. R. Rahman's North American Tour.", image: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/4tyrelo8_ar-rahman-film-79.webp" },
  { year: "2024", title: "She Came Back", desc: "A haunting near-death thriller hits screens.", image: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/2w3fsn2m_maxresdefault%20%281%29.jpg" },
  { year: "2026", title: "STEP UP", desc: "Live dance championship lights up Toronto.", image: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/pzr6qbr9_artical%20cover%20image.png" },
];

export const GALLERY = [
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/4zje6e3r_WhatsApp%20Image%202026-08-24%20at%208.11.48%20AM%20%281%29.webp", category: "STEP UP" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/a2riid1a_WhatsApp%20Image%202026-08-24%20at%208.11.48%20AM%20%282%29.webp", category: "STEP UP" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/dw4zzx9e_WhatsApp%20Image%202026-08-24%20at%208.11.48%20AM%20%283%29.webp", category: "STEP UP" },
  { src: "https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200", category: "Concerts" },
  { src: "https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", category: "Film" },
  { src: "https://images.unsplash.com/photo-1593508512255-86ab42a8e620?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", category: "VR" },
  { src: "https://images.unsplash.com/photo-1531651008558-ed1740375b39?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", category: "Music" },
  { src: "https://images.pexels.com/photos/30518233/pexels-photo-30518233.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200", category: "Concerts" },
  { src: "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", category: "Concerts" },
  { src: "https://images.unsplash.com/photo-1518930259200-3e5b29f42096?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", category: "Film" },
];

export const GALLERY_CATEGORIES = ["All", "STEP UP", "Concerts", "Film", "Music", "VR"];

export const CLIENT_LOGOS = [
  "YM Movies",
  "Thenandal Studios",
  "Zilvermeer Productions",
  "Intel",
  "A. R. Rahman",
];

export const NEWS = [
  {
    slug: "step-up-toronto-prabhu-deva",
    title: "STEP UP: Where Toronto's Next Generation Took the Stage",
    date: "August 22, 2026",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/pzr6qbr9_artical%20cover%20image.png",
    heroImage: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/e7zvb102_Hero%20section%20bg%20image.webp",
    excerpt:
      "A new dance championship brought emerging South Asian talent together with Indian dance icon Prabhu Deva — creating a platform that connected Toronto's creative community with the wider South Asian entertainment world.",
    body: [
      { type: "p", text: "A new dance championship brought emerging South Asian talent together with Indian dance icon Prabhu Deva — creating a platform that connected Toronto's creative community with the wider South Asian entertainment world." },
      { type: "p", text: "On August 22, 2026, the Great Canadian Casino Resort Toronto became the setting for an evening built around movement, competition and possibility." },
      { type: "p", text: "Presented by Ideal Dream Entertainment, STEP UP brought eight of Canada's emerging dance crews together for a live championship, with legendary Indian performer Prabhu Deva joining the event as a special presence." },
      { type: "p", text: "But STEP UP was about more than bringing a celebrated name to Toronto. It was about putting the spotlight on the dancers themselves." },
      { type: "p", text: "At a time when South Asian culture continues to expand its influence around the world, the event represented a larger question: what happens when the diaspora is given the platforms to create its own entertainment ecosystem rather than simply consume culture produced elsewhere?" },
      { type: "p", text: "For Toronto-based producer, founder and entertainment executive Shaji Nada, that question has been central to his work." },
      { type: "p", text: "Through Ideal Entertainment and his work as co-founder of Maajja with A.R. Rahman, Nada has focused on developing platforms and opportunities that can help South Asian artists and stories move beyond geographical and cultural boundaries." },
      { type: "p", text: "STEP UP brought that philosophy to the dance floor." },
      { type: "h2", text: "Eight Crews. One Stage." },
      { type: "p", text: "The championship featured eight finalist crews: AJ Dance, K2B Movement, Mumbai Troopers, Prima Dance School, ADA, Mudra, ARIMA and Maja Crew." },
      { type: "p", text: "Each team brought its own choreography, personality and interpretation of dance to the competition, showcasing the creative diversity developing within Canada's South Asian and multicultural dance community." },
      { type: "p", text: "The road to the championship began with online submissions and a qualification process that ultimately produced the Top 8. The live finale then gave the finalists the opportunity to perform in front of an audience — with an Audience Choice Award adding another layer of participation to the competition." },
      { type: "p", text: "For many of the dancers, however, the defining element was the opportunity to share the stage with one of Indian cinema's most recognizable dance figures." },
      { type: "h2", text: "A Legend Meets the Next Generation" },
      { type: "p", text: "For decades, Prabhu Deva has been one of the defining forces in Indian dance and popular cinema. His distinctive movement vocabulary helped reshape screen choreography, drawing from a wide range of influences and inspiring generations of performers across India and beyond." },
      { type: "p", text: "Having an artist of that stature present at STEP UP created a powerful connection between generations. The dancers weren't simply watching an icon perform. They were performing within the same larger space — turning the idea of inspiration into something tangible." },
      { type: "img", src: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/a2riid1a_WhatsApp%20Image%202026-08-24%20at%208.11.48%20AM%20%282%29.webp", caption: "Dance legend Prabhu Deva with Toronto Mayor Olivia Chow at the event." },
      { type: "p", text: "For emerging artists, moments like these can matter because they transform a distant influence into a real-world experience." },
      { type: "h2", text: "Building More Than Events" },
      { type: "p", text: "The larger story behind STEP UP is connected to Shaji Nada's approach to entertainment. Nada's work has repeatedly centred on the idea that talent alone is not enough. Artists also need platforms, producers, audiences, partnerships and infrastructure capable of carrying their work forward." },
      { type: "p", text: "That philosophy has shaped his work across entertainment and music, including his involvement with Maajja, the independent music platform he co-founded with A.R. Rahman." },
      { type: "p", text: "The objective is not simply to create content for a South Asian audience. It is to create opportunities for South Asian artists to participate in global culture on their own terms." },
      { type: "p", text: "STEP UP applies that thinking to dance. The important question is no longer simply whether talented dancers exist. They clearly do. The question is whether enough platforms exist to help those dancers turn talent into opportunity." },
      { type: "h2", text: "Toronto as a Creative Hub" },
      { type: "p", text: "Toronto's South Asian community is one of the city's defining cultural forces. Yet a large community and a sustainable entertainment ecosystem are not automatically the same thing." },
      { type: "p", text: "An industry requires infrastructure. It requires venues, producers, festivals, audiences, partnerships, media and opportunities that allow artists to move from local recognition toward larger stages." },
      { type: "p", text: "That is where STEP UP takes on a significance beyond the competition itself. The dancers were not positioned merely as supporting performers around a visiting celebrity. They were the centre of a championship created around their craft." },
      { type: "p", text: "And the opportunities attached to the competition extended beyond Toronto. The winning crew earns the opportunity to perform at YAALL Festival in Chennai, valued at $10,000, along with a featured appearance in an upcoming Maajja music video." },
      { type: "p", text: "That changes the meaning of the prize. It is not simply recognition. It is a potential pathway. A crew can begin its journey in Toronto and find itself performing in Chennai. Canadian dancers can connect with a South Asian music platform. A local competition can create an international introduction." },
      { type: "p", text: "That kind of cross-border movement is an important part of building a connected South Asian creative ecosystem." },
      { type: "img", src: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/4zje6e3r_WhatsApp%20Image%202026-08-24%20at%208.11.48%20AM%20%281%29.webp", caption: "A civic proclamation at Toronto City Hall recognising the STEP UP initiative." },
      { type: "h2", text: "When Dance Connects to Music" },
      { type: "p", text: "The relationship between STEP UP and Maajja adds another dimension to the event. Music and dance have always influenced one another. Choreography can transform the way an audience experiences a song, while music can give dancers a language through which to create entirely new movements." },
      { type: "p", text: "By connecting the winning crew with a potential Maajja music-video opportunity, STEP UP creates a direct bridge between Canada's dance community and a broader South Asian music network. The competition therefore becomes more than a single performance. It becomes a potential starting point." },
      { type: "img", src: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/dw4zzx9e_WhatsApp%20Image%202026-08-24%20at%208.11.48%20AM%20%283%29.webp", caption: "The championship trophy presentation, presented by Ideal Dream Entertainment." },
      { type: "h2", text: "Measuring Success Differently" },
      { type: "p", text: "Events are often measured by attendance, production value or the celebrity names attached to them. But cultural platforms can be measured in other ways." },
      { type: "p", text: "Who received an opportunity? Who discovered a new audience? Who was seen by someone who might open the next door? Who left the room believing that a career in the arts was possible? And perhaps most importantly — what remains after the event is over?" },
      { type: "p", text: "Those questions matter particularly within diaspora communities. One generation may establish the audience. The next begins developing a creative identity. Eventually, that identity can develop into an industry." },
      { type: "p", text: "STEP UP is part of that progression. It gives emerging dancers a serious platform, brings audiences together around local talent and creates a connection between an established Indian entertainment legacy and the new generation of artists developing in Canada." },
      { type: "h2", text: "The Stage Is Only the Beginning" },
      { type: "p", text: "On August 22, the lights at the Great Canadian Casino Resort Toronto illuminated eight dance crews competing for a championship. But the larger significance of STEP UP lies beyond that single night." },
      { type: "p", text: "It represents an idea: that the next generation of South Asian artists in Canada should have more than audiences. They should have stages. They should have pathways. They should have opportunities to collaborate across borders and industries. And they should have the infrastructure to turn local talent into global careers." },
      { type: "p", text: "That is the larger vision behind the event — and one that aligns closely with Shaji Nada's broader work in South Asian entertainment." },
      { type: "p", text: "The future of South Asian entertainment in North America will not be defined only by how many established stars can be brought to Canadian stages. It will also be defined by how many new stars can emerge from those stages." },
      { type: "p", text: "STEP UP was one night in Toronto. The opportunity it created could travel much further." },
    ],
  },
  {
    slug: "ar-rahman-99-songs-hindi-trailer",
    title: "AR Rahman unveils Hindi trailer of 99 Songs; film to release in cinemas on 16 April",
    date: "September 20, 2023",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/1nolg9q7_99_Songs.webp",
    heroImage: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/1nolg9q7_99_Songs.webp",
    excerpt:
      "99 Songs, directed by Vishwesh Krishnamoorthy, features newcomers Ehan Bhat, Tenzin Dalha and Edilsy Varghese.",
    body: [
      { type: "p", text: "Music maestro A. R. Rahman unveiled the Hindi trailer of 99 Songs, the romantic musical that marks his debut as a writer and producer. The film released in cinemas on 16 April in Hindi, Tamil and Telugu." },
      { type: "p", text: "Directed by Vishwesh Krishnamoorthy in his directorial debut, 99 Songs introduces newcomer Ehan Bhat in the lead, alongside Edilsy Varghese and Tenzin Dalha, with an ensemble cast that includes celebrated names from across Indian cinema." },
      { type: "p", text: "The trailer offered a first glimpse into the film's world — a young musician's journey through love, loss and the relentless pursuit of his art, set to an original soundtrack composed by Rahman himself." },
      { type: "p", text: "Produced by A. R. Rahman under YM Movies in association with Jio Studios, 99 Songs was conceived as an experiential film where the music is inseparable from the story." },
    ],
  },
  {
    slug: "99-songs-ar-rahman-experiential-movie",
    title: "99 Songs is about one man's struggle against the old and new world: AR Rahman",
    date: "September 20, 2023",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/03pktkw3_images%20%281%29.jpg",
    excerpt:
      "Describing his maiden production 99 Songs as an 'experiential movie', music maestro AR Rahman says the film revolves around a young musician's journey.",
    body: [
      { type: "p", text: "Describing his maiden production as an 'experiential movie', A. R. Rahman said 99 Songs revolves around a young musician's journey and his struggle against both the old and the new world." },
      { type: "p", text: "At the heart of the story is a challenge: to prove his worth and win the woman he loves, the protagonist must compose 99 songs. What follows is a deeply personal odyssey about creativity, sacrifice and self-discovery." },
      { type: "p", text: "For Rahman, the film was an opportunity to tell a story in which music was not merely a backdrop but the very language of the narrative — a natural extension of a career defined by boundary-pushing soundscapes." },
      { type: "p", text: "The film reflects Ideal Entertainment's wider philosophy: creating innovative content and soulful experiences with multi-faceted, talented artists on a worldwide platform." },
    ],
  },
  {
    slug: "99-songs-directorial-debut-vishwesh-krishnamoorthy",
    title: "99 SONGS — the directorial debut of Vishwesh Krishnamoorthy",
    date: "September 20, 2023",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/90f6d233_Group%20703.png",
    heroImage: "https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/90f6d233_Group%20703.png",
    excerpt:
      "A feature-length romantic-musical, '99 Songs' marks the directorial debut of Vishwesh Krishnamoorthy.",
    body: [
      { type: "p", text: "A feature-length romantic musical, 99 Songs marks the directorial debut of Vishwesh Krishnamoorthy, working from a story written by A. R. Rahman." },
      { type: "p", text: "The film blends a coming-of-age love story with a rich, original score, following a gifted young musician as he navigates ambition, romance and the price of artistic devotion." },
      { type: "p", text: "Released across multiple languages, 99 Songs brought together emerging talent and seasoned collaborators, showcasing the kind of ambitious, music-driven storytelling that Ideal Entertainment continues to champion." },
    ],
  },
];

export const PROJECT_TYPES = [
  "Film Production",
  "Music Production",
  "Live Event / Concert",
  "VR / Immersive Experience",
  "Documentary / Original Content",
  "Brand Collaboration",
  "Other",
];

export const BUDGET_RANGES = [
  "Under $50K",
  "$50K – $250K",
  "$250K – $1M",
  "$1M+",
  "Not sure yet",
];
